module.exports = __webpack_public_path__ + "prizes.979532d2.png";